/**
 * Snapshot used only when NODE_ENV === "development" and the user navigates to
 * /checkout/confirm without a real lastFinishedCart (see fixCheckoutPageStep).
 *
 * NOTE: Resend emails and the hear-about-BA survey submit/dismiss APIs require an order ID
 * and email that match a completed order in your local database. For cosmetic-only work,
 * any email and order ID are fine; dismiss the survey modal to close it without a real order.
 */
const OpsCheckoutForm = require("../vault/OpsCheckoutForm");

const DEV_MOCK_ORDER_ID = 1080773;

const FORM_SECTIONS = [
	"contact",
	"account",
	"shipping",
	"billing",
	"creditCard",
];

const SECTION_VALS = {
	contact: {
		phone: "0123456789",
		email: "tstone@aops.com",
		comments: "Dev-only mock order confirmation preview.",
	},
	account: {
		ownerID: null,
		email: "tstone@aops.com",
		emailRepeat: "dev-mock-confirm@example.invalid",
		password: "password",
		passwordRepeat: "password",
		exists: false,
		remember: false,
	},
	shipping: {
		name: "Dev Test",
		country: "US",
		address1: "15330 Avenue of Science",
		address2: "",
		city: "San Diego",
		state: "CA",
		zipcode: "92128",
		method: "us-economy",
		comments: "",
		taxpayerID: "",
	},
	billing: {
		name: "Dev Test",
		country: "US",
		address1: "15330 Avenue of Science",
		address2: "",
		city: "San Diego",
		state: "CA",
		zipcode: "92128",
	},
	creditCard: {
		number: "4111111111111111",
		cvv: "123",
		expMonth: 1,
		expYear: 2050,
		agreeRecurring: false,
	},
};

/**
 * @returns {Object} Cart-shaped object suitable for cart.lastFinishedCart
 */
module.exports = function buildDevMockLastFinishedCart(now) {
	const t = now || Date.now();
	let form = OpsCheckoutForm.init("cart", t);
	FORM_SECTIONS.forEach(section => {
		const {form: next} = OpsCheckoutForm.updateData(
			form,
			section,
			SECTION_VALS[section],
			{
				needsRecurringBilling: false,
				shouldSkipPhoneValidation: false,
			}
		);
		form = next;
	});

	return {
		orderID: DEV_MOCK_ORDER_ID,
		items: [
			{sku: "beast-3a", quantity: 1, options: {}},
			{sku: "beast-3a-practice", quantity: 1, options: {}},
		],
		prices: {
			subtotal: "45.00",
			couponApplied: "0.00",
			shipping: "5.99",
			tax: "0.00",
		},
		form,
		coupon: null,
		subscribeOnCheckout: true,
		userDidSetSubscribe: false,
		onPaypalFlow: false,
		isClassWalletFlow: false,
		academyCampusURL: null,
	};
};
